import { Component, Injector, Input, OnInit, inject } from '@angular/core';
import { IonRouterOutlet, ModalController, IonicModule } from '@ionic/angular';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { MapComponent } from '../../../components/map/map.component';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppState } from 'src/app/app.module';
import { settingsFeature } from 'src/app/ngrx/settings/settings.feature';
import { SettingsActions } from 'src/app/ngrx/settings/settings.actions';

@Component({
    selector: 'app-campus-navi',
    templateUrl: './campus-navi.page.html',
    styleUrls: ['./campus-navi.page.scss'],
    imports: [IonicModule, MapComponent, AsyncPipe, TranslatePipe]
})
export class CampusNaviPage implements OnInit {
  modalController = inject(ModalController);
  private injector = inject(Injector);
  private store = inject<Store<AppState>>(Store);

  constructor() {
    this.enabledCategories = this.store.pipe(select(settingsFeature.selectCampusNaviRememberedCategories));
  }

  public enabledCategories: Observable<number[]>;

  @Input()
  public showCategories: boolean = true;

  @Input()
  public trackUserLocation: boolean = true;

  @Input()
  public isModal: boolean = false;

  async ngOnInit(): Promise<void> {
    if(!this.isModal) {
      const routerOutlet: IonRouterOutlet = this.injector.get(IonRouterOutlet);
      routerOutlet.swipeGesture = false;
    }
  }

  public async ionViewWillLeave() {
    if(await this.modalController.getTop()) {
      this.modalController.dismiss();
    }
  }
  
  protected changeCategories(categories?: number[]): void {
    const normalizedCategories: number[] = categories ?? [];
    this.store.dispatch(SettingsActions.changeRememberedNaviCategories({ categories: normalizedCategories }));
  }
}
